import { observable } from 'mobx';

export type ElementType = 'hotel' | 'shinkansen' | 'express' | 'domestic_air' | 'foreign_air' | 'rental_car';

export interface TripDuplicationResponseArgs {
  trip_id: number;
  user_name: string;
  element_types: ElementType[];
}

export type TripDuplicationArgs = {
  tripId: number;
  userName: string;
  elementTypes: ElementType[];
};

export const convertTripDuplicationResponseToArgs = (response: TripDuplicationResponseArgs) => {
  const args: TripDuplicationArgs = {
    tripId: response.trip_id,
    userName: response.user_name,
    elementTypes: response.element_types
  };
  return args;
};

export default class TripDuplication {
  @observable tripId: number;
  @observable userName: string;
  @observable elementTypes: ElementType[];

  constructor(args: TripDuplicationArgs) {
    this.tripId = args.tripId;
    this.userName = args.userName;
    this.elementTypes = args.elementTypes;
  }

  get updateParams(): TripDuplicationResponseArgs {
    return {
      trip_id: this.tripId,
      user_name: this.userName,
      element_types: this.elementTypes
    };
  }
}
